import { inject, injectable } from 'inversify';

import { Enums, UIDtoFactory } from '@project44-models/iam-gateway';

import { UnifiedRolesEditorPolicyResolverEnum } from '../../domain/enums';
import { IUnifiedRolesFactory } from '../../domain/interfaces';
import { UnifiedRolesEditor } from '../../domain/UnifiedRolesEditor';
import { UnifiedRolesEditorPolicyResolver } from '../../domain/UnifiedRolesEditorPolicy.resolver';

@injectable()
export class UnifiedRolesFactory implements IUnifiedRolesFactory {
  constructor(
    @inject(UnifiedRolesEditorPolicyResolver)
    private readonly unifiedRolesEditorPolicyResolver: UnifiedRolesEditorPolicyResolver,

    @inject(UnifiedRolesEditor)
    private readonly unifiedRolesEditor: UnifiedRolesEditor,
  ) {}

  public readonly createUnifiedRolesDto: IUnifiedRolesFactory['createUnifiedRolesDto'] =
    (maybeUnifiedRoleCollection) => {
      return UIDtoFactory.create(
        Enums.UiDtoFactoryEnum.UNIFIED_ROLE_COLLECTION,
        maybeUnifiedRoleCollection || {},
      );
    };

  public readonly createUnifiedRolesEditorPolicy: IUnifiedRolesFactory['createUnifiedRolesEditorPolicy'] =
    (payload) => {
      const unifiedRolesAssignedToResource =
        payload.unifiedRolesAssignedToResource || this.createUnifiedRolesDto();

      const allAvailableUnifiedRoles =
        payload.allAvailableUnifiedRoles || this.createUnifiedRolesDto();

      const UnifiedRolesEditorPolicyConstructor =
        this.unifiedRolesEditorPolicyResolver.resolveUnifiedRolesEditorPolicy(
          UnifiedRolesEditorPolicyResolverEnum.DEFAULT_POLICY,
        );

      return new UnifiedRolesEditorPolicyConstructor({
        unifiedRolesEditor: this.unifiedRolesEditor,
        unifiedRolesAssignedToResource,
        allAvailableUnifiedRoles,
      });
    };
}
